export default function (
    element,
    speed = 1000,
    easing = "swing",
    callback = false
) {
    $('html, body').animate({
        scrollTop: $(element).offset().top,
    }, speed, easing, callback)
}



// WEBPACK FOOTER //
// ./scripts/util/ScrollTo.js